import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import {
  fetchCreateAnswer,
  ICreateAnswerResponse400,
  ICreateAnswerResponse200,
} from '../../repositories/newbuilding-reviews/v1/create-answer';
import { INewAnswer } from '../../types/newAnswer';
import { prepareNewAnswer } from '../../mappers/prepareNewAnswer';

export interface IFetchAnswerParams {
  httpApi: IHttpApi;
  parameters: {
    reviewId: string;
    newAnswer: INewAnswer;
  };
}

export async function addAnswer({ httpApi, parameters: { reviewId, newAnswer } }: IFetchAnswerParams): Promise<void> {
  const result = await fetchCreateAnswer<ICreateAnswerResponse200, ICreateAnswerResponse400>({
    httpApi,
    parameters: prepareNewAnswer(reviewId, newAnswer),
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'reviews#fetchAddAnswer',
      message: '',
    });
  }
}
